import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const MediaSectionModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t('Challenge Description')}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p>
                    {t(`For challenge description you can upload any number of images, videos and HTML chunks.`)}
                </p>
                <p>
                    {t(`The last image in the carousel will be used as the challenge image on the challenge list.`)}
                </p>
                <p>
                    {t(`When someone enters the challenge, the first panel of your carousel will be shown. We recommend using it for your challenge description.`)}
                </p>
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t('Close')}
                </Button>
            </div>
        </Modal>
    )
};

export default MediaSectionModal;
